import actionTypes from '../../action-types'

export default (customerProductId, badgeId = null) => ({
  type: actionTypes.USER_GROUPS.FETCH_ALL,
  payload: {
    customerProductId,
    badgeId,
  },
})
